import React, { CSSProperties, ReactNode, useState } from 'react';
import DataTableNew from '../../../components/main/DataTableNew/DataTableNew';
import DeleteWorksetsDialog from '../../../components/dialogs/DeleteWorksetsDialog/DeleteWorksetsDialog';
import NewWorksetDialog from '../../../components/dialogs/NewWorksetDialog/NewWorksetDialog';
import { UserRoleEnum, Workset } from '../../../generated/graphql';
import ShowOnRole from '../../../components/main/ShowOnRole/ShowOnRole';
import { Plus, Trash2 } from 'lucide-react';
import RefreshButton from '../../../components/main/RefreshButton/RefreshButton';

type WorksetsProps = {
    refresh: () => void;
    worksets: (Workset | null | undefined)[],
    isLoading: boolean,
    projectId: string,
    isAdmin: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const Worksets = (props: WorksetsProps) => {
    const { worksets, isAdmin, isLoading, projectId, refresh } = props;
    const [newWorksetVisible, setNewWorksetVisible] = useState(false);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [deleteWorksetsDialogVisible, setDeleteWorksetsDialogVisible] = useState(false);

    const handleDeleteWorksetOnClose = () => {
        setDeleteWorksetsDialogVisible(false);
        refresh();
    };
    const handleNewWorksetDialogOnClose = () => {
        setNewWorksetVisible(false);
        refresh();
    };

    return (
        <div className="flex flex-col h-full">
            <div className="flex items-center gap-2 px-4 py-2.5 border-b" style={{ borderColor: 'var(--border-default)' }}>
                <RefreshButton onRefresh={() => refresh()} />
                <ShowOnRole roles={[UserRoleEnum.Admin]} isAdmin={isAdmin}>
                    <button className="btn btn-ghost text-sm" onClick={() => setNewWorksetVisible(true)}>
                        <Plus size={15} /> New Workset
                    </button>
                    {selectedIds.length > 0 && (
                        <>
                            <div className="w-px h-5 mx-1" style={{ backgroundColor: 'var(--border-default)' }} />
                            <button className="btn btn-ghost text-sm" style={{ color: 'var(--danger)' }} onClick={() => setDeleteWorksetsDialogVisible(true)}>
                                <Trash2 size={15} /> Delete
                            </button>
                        </>
                    )}
                </ShowOnRole>
            </div>

            <div className="flex flex-col flex-1 overflow-hidden">
                <DataTableNew
                    sortingMode="client"
                    isLoading={isLoading}
                    data={worksets as any[]}
                    columns={[{ id: 'group', name: 'Group', sortable: true }]}
                    onSelected={(ids) => setSelectedIds(ids)}
                />
            </div>

            <NewWorksetDialog projectId={projectId} visible={newWorksetVisible} onClose={handleNewWorksetDialogOnClose} />
            <DeleteWorksetsDialog projectId={projectId} ids={selectedIds} visible={deleteWorksetsDialogVisible} onClose={handleDeleteWorksetOnClose} />
        </div>
    );
};

export default Worksets;
